import { render, staticRenderFns } from "./ShouyeBottom.vue?vue&type=template&id=23498019&scoped=true&"
import script from "./ShouyeBottom.vue?vue&type=script&lang=js&"
export * from "./ShouyeBottom.vue?vue&type=script&lang=js&"
import style0 from "./ShouyeBottom.vue?vue&type=style&index=0&id=23498019&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23498019",
  null
  
)

export default component.exports